export enum BookedVisitStatusType {
  BOOKED = 'BOOKED',
  PASSED = 'PASSED',
  CLOSE_OUT_OVERDUE = 'CLOSE_OUT_OVERDUE',
  CLOSE_OUT_COMPLETED = 'CLOSE_OUT_COMPLETED',
  UNKNOWN = 'UNKNOWN',
}

const asStrings: string[] = Object.values(BookedVisitStatusType);
const asArray: BookedVisitStatusType[] = Object.keys(BookedVisitStatusType) as BookedVisitStatusType[];

export const BookedVisitStatusTypes = {
  asStrings,
  asArray,
};
